import { Headphones } from "lucide-react";
import { RunsText, ForYou } from "@/components/appointments/MessageCard";

function Group({ g, start, testid }) {
  return (
    <section className={`rounded-2xl p-4 sm:p-5 ${g.overflow ? "bg-[#F7F5EF] border border-dashed border-[#C9A961]" : "bg-white border border-slate-200"}`} data-testid={testid}>
      <h3 className="font-serif text-base text-[#0A1F44] mb-3">{g.overflow ? "If the PBO listens faster — more podcasts" : g.label}</h3>
      <ol className="space-y-2">
        {g.talks.map((t, i) => (
          <li key={i} className="flex items-start gap-3">
            <span className="w-7 h-7 rounded-full bg-[#0A1F44] text-[#C9A961] text-[11px] font-semibold flex items-center justify-center shrink-0">{start + i}</span>
            <div className="min-w-0">
              <div className="text-sm font-semibold text-slate-900">{t.title}</div>
              <div className="text-xs text-slate-500">{t.speaker}</div>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}

export default function Podcasts({ stage }) {
  const main = stage.groups.filter((g) => !g.overflow);
  const extra = stage.groups.filter((g) => g.overflow);
  let n = 1;
  return (
    <div className="space-y-5" data-testid="appt-podcasts">
      <p className="text-xs text-slate-500">This is the PBO vetting assignment list — not the post-launch T1G/SEPL library.</p>
      <div className="grid gap-3 sm:grid-cols-2">
        {stage.info.map((s, i) => (
          <section key={i} className="rounded-xl border border-slate-200 bg-white p-4" data-testid={`appt-podcasts-info-${i}`}>
            <div className="text-[10px] uppercase tracking-[0.2em] text-[#8A6D1F] font-semibold mb-1.5">{s.label}</div>
            <RunsText runs={s.body} />
            <ForYou runs={s.note} />
          </section>
        ))}
      </div>
      {stage.order_note && (
        <div className="flex items-center gap-2 text-sm font-medium text-[#0A1F44]"><Headphones className="w-4 h-4 text-[#C9A961]" /> {stage.order_note}</div>
      )}
      <div className="grid gap-3 sm:grid-cols-2">
        {main.map((g, i) => { const s = n; n += g.talks.length; return <Group key={i} g={g} start={s} testid={`appt-podcasts-group-${i}`} />; })}
      </div>
      {extra.map((g, i) => { const s = n; n += g.talks.length; return <Group key={i} g={g} start={s} testid="appt-podcasts-overflow" />; })}
    </div>
  );
}
